import { Outlet, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { zSearchText } from '@/shared/lib/search';

const performanceSearchSchema = z.object({ period: zSearchText(), asAt: zSearchText(), view: zSearchText(), employment: zSearchText(), stuck: zSearchText(), product: zSearchText(), measure: zSearchText(), show: zSearchText(), charts: zSearchText() });

export const Route = createFileRoute('/_app/performance')({
  validateSearch: performanceSearchSchema,
  staticData: { crumb: 'nav.performance', crumbTo: '/performance' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'performance.view', 'Performance'),
  component: Outlet,
});
